import React from 'react'

function Buy() {
  return (
    <div>Buy</div>
  )
}

export default Buy